<template lang="html">
  <div class="flex flex-col gap-4">
    <div
      v-for="attr in keyAttributes"
      :key="attr.attrId"
      class="flex flex-col gap-2"
    >
      <span class="text-sm font-medium text-muted">
        {{ attr.displayName }}
      </span>
      <div class="flex flex-wrap">
        <UButton
          v-for="val in attr.values"
          :key="val.value"
          :label="val.displayName ?? val.value"
          :active="selectedValues[attr.attrId] === val.value"
          :disabled="!isValueAvailable(attr.attrId, val.value)"
          active-variant="solid"
          active-color="tertiary"
          variant="outline"
          color="neutral"
          size="sm"
          @click="selectValue(attr.attrId, val.value)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductDto } from '@repo/api/web/models'

import { useVariantsNavigation } from '#Products/composables/useVariantsNavigation'

const props = withDefaults(
  defineProps<{
    value: ProductDto
    activeId: number
  }>(),
  {},
)

const { keyAttributes, selectedValues, isValueAvailable, selectValue }
  = useVariantsNavigation(toRef(props, 'value'), toRef(props, 'activeId'))
</script>
